import { render, staticRenderFns } from "./OpenBankingPaymentActivity.vue?vue&type=template&id=08dc0d6b"
import script from "./OpenBankingPaymentActivity.vue?vue&type=script&lang=js"
export * from "./OpenBankingPaymentActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports